import routes from '@routes';
import { CacheProps, fetchApi } from '../../../fetch';

const getComplaintsTypesApi = ({ ...rest }: CacheProps) => {
  return fetchApi({
    method: 'GET',
    URL: routes['api.client.complaints-types'],
    withToken: true,
    cache: 'no-cache',
    ...rest,
  });
};

export default getComplaintsTypesApi;
